//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { IUrlRouterProvider } from 'angular-ui-router';

import {
  IPartialState,
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasAllFeatures,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

// Sets default values for state data
function ScheduleStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess ?? (() => true);
  const data = {
    title: 'Schedule',
    navGroup: NavGroup.PUBLISHING,
    ...state.data,
    hasAccess: () =>
      hasAllFeatures(FeatureNames.Social, FeatureNames.SocialDashboards) &&
      accessFn(),
  };

  return StateFactory({
    ...state,
    data,
  });
}

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  // TODO: PD-240739: Clean up UniversalScheduler feature flag once released
  const isUniversalSchedulerFeatureEnabled = hasFeature(
    FeatureNames.UniversalScheduler,
  );

  if (!isUniversalSchedulerFeatureEnabled) {
    urlRouterProvider.when('/schedule/scheduler', '/schedule/calendar');
  }
}

export const states = {
  schedule: ScheduleStateFactory({
    url: '/schedule',
    redirectTo: 'schedule.calendar',
    template: componentNameToTemplate('schedulePage'),
    resolve: {
      ...lazyLoadModule(
        'curalate.schedule',
        () => import('@universal-scheduling/ScheduleApp'),
      ),
    },
  }),

  'schedule.calendar': ScheduleStateFactory({
    url: '/calendar?:startDate&:endDate&:view',
    views: {
      'schedule-header': {
        template: componentNameToTemplate('calendarHeader'),
      },
    },
  }),

  'schedule.drafts': ScheduleStateFactory({
    url: '/drafts',
    views: {
      'schedule-header': {
        template: componentNameToTemplate('draftsHeader'),
      },
    },
  }),
  'schedule.scheduler': ScheduleStateFactory({
    url: '/scheduler?:postType&:copiedScheduledPostId&:copiedDraftId&:targetCuid&:scheduledPostId&:draftPostId&:postTimeMs&:entryNetwork',
    data: {
      // TODO: PD-240739: Clean up UniversalScheduler feature flag once released
      hasAccess: () => hasFeature(FeatureNames.UniversalScheduler),
    },
    views: {
      'schedule-header': {
        template: componentNameToTemplate('schedulerHeader'),
      },
    },
  }),
};
